'use client';
import { useMemo } from 'react';
import { useSearchParams } from 'next/navigation';
import { useLocale, useTranslations } from 'next-intl';

import Breadcrumbs, { ItemType } from '@/ui/components/Breadcrumbs';
import { Product } from '@/types/restResponses/info';

import { buildBreadcrumbsWithProductContext } from './utils';

interface ContextAwareBreadcrumbsProps {
  items: ItemType;
  products?: Product[];
}

export default function ContextAwareBreadcrumbs({ items, products }: ContextAwareBreadcrumbsProps) {
  const translate = useTranslations();
  const searchParams = useSearchParams();
  const locale = useLocale();
  const productSlug = searchParams.get('product');

  const { breadcrumbItems } = useMemo(
    () => buildBreadcrumbsWithProductContext(items, productSlug, products, locale),
    [items, productSlug, products, locale]
  );

  return <Breadcrumbs base={translate('breadcrumb-support')} items={breadcrumbItems} />;
}
